<template>
  <el-container class="layout-container">
    <!-- 侧边栏 -->
    <el-aside :width="isCollapsed ? '64px' : '220px'" class="sidebar">
      <el-menu
        :default-active="activeMenu"
        class="el-menu-vertical"
        @select="handleMenuSelect"
        background-color="#08455d"
        text-color="#fff"
        active-text-color="#409EFF"
        :collapse="isCollapsed"
        :collapse-transition="false"
      >
        <el-sub-menu index="setHomePage">
          <template #title>
            <el-icon><HomeFilled /></el-icon>
            <span>ホーム画面設定</span>
          </template>
          <el-menu-item index="/main/heroInfo">
            <span >ヒーロー情報</span>
          </el-menu-item>
          <el-menu-item index="/main/serviceInfo">
            <span >サービス情報</span>
          </el-menu-item>
          <el-menu-item index="/main/productList">
            <span >販売品一覧</span>
          </el-menu-item>
          <el-menu-item index="/main/contactInfoView">
            <span >問い合わせ情報</span>
          </el-menu-item>
        </el-sub-menu>

        <el-sub-menu index="serviceList">
          <template #title>
            <el-icon><Management /></el-icon>
            <span>サービス一覧</span>
          </template>
          <el-menu-item index="/main/usedCarList">
            <span >中古車一覧</span>
          </el-menu-item>
          <el-menu-item index="/main/usedPartList">
            <span >中古パーツ一覧</span>
          </el-menu-item>
        </el-sub-menu>

        <el-sub-menu index="master">
          <template #title>
            <el-icon><HelpFilled /></el-icon>
            <span>マスタ</span>
          </template>
          <el-menu-item index="/main/companyInfoView">
            <span >会社情報設定</span>
          </el-menu-item>
          <el-menu-item index="/main/manufacturerMaster">
            <span >メーカー設定</span>
          </el-menu-item>
          <el-menu-item index="/main/modelMaster">
            <span >車種設定</span>
          </el-menu-item>
          <el-menu-item index="/main/aboutUsedCar">
            <span >中古車販売お知らせ</span>
          </el-menu-item>
          <el-menu-item index="/main/pointUsedCar">
            <span >中古車評価点</span>
          </el-menu-item>
          <el-menu-item index="/main/aboutUsedPart">
            <span >中古パーツ販売お知らせ</span>
          </el-menu-item>
          <el-menu-item index="/main/pointUsedpart">
            <span >中古パーツ評価点</span>
          </el-menu-item>
          </el-sub-menu>
      </el-menu>
    </el-aside>

    <el-container>
      <!-- 顶部导航栏 -->
      <el-header class="header">
        <el-icon @click="toggleSidebar" class="menu-icon"><Menu /></el-icon>
        <span class="title">SEIEI Admin</span>
        <el-dropdown class="user-dropdown">
          <el-avatar size="medium" src="/logo.jpg" />
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item @click="logout">Logout</el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </el-header>

      <!-- 主内容区域 -->
      <el-main class="main-content">
        <router-view />
      </el-main>
    </el-container>
  </el-container>
</template>

<script setup>
import { ref } from "vue";
import { useRouter } from "vue-router";
import { HelpFilled, Menu, HomeFilled ,Management} from "@element-plus/icons-vue";
import { supabase } from '@/supabase.js'

const router = useRouter();
const activeMenu = ref("dashboard");
const isCollapsed = ref(false);

const toggleSidebar = () => {
  isCollapsed.value = !isCollapsed.value;
};

const handleMenuSelect = (index) => {
  activeMenu.value = index;
  console.log("ddd:"+index)
  router.push(`${index}`);
};

const logout = async() => {
  await supabase.auth.signOut();
  router.push("/login");
};
</script>

<style lang="stylus" scoped>
.layout-container
  height 100vh

.sidebar
  background #304156
  color #fff
  transition all 0.3s ease

.header
  height 60px
  background #ffffff
  border-bottom 1px solid #ddd
  display flex
  align-items center
  justify-content space-between
  padding 0 20px

.menu-icon
  cursor pointer
  font-size 20px
  margin-right 10px

.title
  font-size 20px
  font-weight bold

.user-dropdown
  cursor pointer

.main-content
  padding 20px
  background #f5f5f5
  min-height calc(100vh - 60px)
.sidebar
  background #08455d !important
  min-width 64px
  transition width 0.2s ease-in-out
  overflow hidden

.el-menu
  min-width 64px
  background #08455d
  border-right none !important
</style>
